import React, { useState, useEffect } from "react";
import { Table, Button, Image, Form, Modal } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import BasicPagination from "../../../Pagination/Pagination";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import { SuperAdminTopTextSearchIcon } from "./AllDonationFilter";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import SearchIcon from "@material-ui/icons/Search";
import {
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  InputBase,
  IconButton,
  Paper,
} from "@material-ui/core";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import {
  get_all_donations,
  get_all_organizations,
  donate_now_to_organization,
  get_referal_donations,
} from "../../../../store/actions/SuperAdminActions/superAdminManageTransactions";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import Alert from "react-s-alert";
import SelectFilter from "../../../reusableComponents/selectFilter";
import { SortComponent } from "../../../reusableComponents/SortAndFilterComponent/SortComponent";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";
import { makeStyles } from "@material-ui/core/styles";

// Animations
import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";
const zoomAnimation = keyframes`${zoomIn}`;
const ZoomDiv = styled.div`
  animation: 1s ${zoomAnimation};
`;

const SuperAdminDonation = (props) => {
  //state
  const [showFilter, seShowFilter] = useState(false);
  const [page, setPage] = useState(1);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    setPage(pageNo);
  };
  const handleShowFilter = () => {
    seShowFilter({
      showFilter: !showFilter.showFilter,
    });
    onClickCancel();
  };
  const [displaySearch, setDisplaySearch] = useState(false);
  const [dateQuery, setDateQuery] = useState("");
  const onDateChangeHandler = (data, type) => {
    setDateQuery(data);
  };

  const [state, setState] = useState({
    search: "",
    anchorEl: null,
    restaurantReverse: "",
    user_type: "",
    statusAction: "",
    showFilter: false,
    userType: "",
    statusType: "",
  });

  const handleClick = (event) => {
    setState({
      ...state,
      anchorEl: event.currentTarget,
    });
  };

  const handleClose = () => {
    setState({
      ...state,
      anchorEl: null,
    });
  };

  const handleSelect = (value) => () => {
    setState({
      ...state,
      restaurantReverse: value,
      anchorEl: false,
    });
  };

  const [selectedOrderType, setSelectedOrderType] = useState("");
  const [selectedOrder, setSelectedOrder] = useState("");

  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [selectedPayment, setSelectedPayment] = useState("");

  const [selectedPaymentTo, setSelectedPaymentTo] = useState("");
  const [selectedPaymentRest, setSelectedPaymentRest] = useState("");

  const [selectedReferedRole, setSelectedReferedRole] = useState("");
  const [selectedReEfered, setSelectedRefered] = useState("");

  const onClickSearch = () => {
    setSelectedOrder(selectedOrderType);
    setSelectedPayment(selectedPaymentMethod);
    setSelectedPaymentRest(selectedPaymentTo);
    setSelectedRefered(selectedReferedRole);
  };

  const onClickCancel = () => {
    setSelectedOrderType("");
    setSelectedOrder("");
    setSelectedPaymentMethod("");
    setSelectedPayment("");
    setSelectedPaymentTo("");
    setSelectedPaymentRest("");
    setSelectedRefered("");
    setSelectedReferedRole("");
  };

  const [sortByDay, setSortByDay] = useState(4);
  const [startDay, setStartDay] = useState("");
  const [endDay, setEndDay] = useState("");

  const changeSortByDay = (e) => {
    setSortByDay(e);
    let startDate = "";
    let endDate = new Date();
    if (e === 2) {
      startDate = new Date(new Date().setDate(new Date().getDate() - 30));
      setStartDay(moment(startDate).format("YYYY-MM-DD"));
      setEndDay(moment(endDate).format("YYYY-MM-DD"));
    } else if (e === 1) {
      startDate = new Date();
      setStartDay(moment(startDate).format("YYYY-MM-DD"));
      setEndDay(moment(endDate).format("YYYY-MM-DD"));
    } else if (e === 3) {
      startDate = new Date(new Date().setDate(new Date().getDate() - 90));
      setStartDay(moment(startDate).format("YYYY-MM-DD"));
      setEndDay(moment(endDate).format("YYYY-MM-DD"));
    }
  };

  const [sortBy, setSortBy] = useState("a");
  const changeSortBy = (e) => {
    setSortBy(e);
  };
  const [showPay, seShowPay] = useState(false);
  const [showPaySuccess, seShowPaySuccess] = useState(false);
  const handleClosePay = () => seShowPay(false);
  const handleShowPay = () => {
    if (checkedId.length > 0) {
      seShowPay(true);
    } else {
      Alert.error(`<h4>Please select donations</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };
  const handleClosePaySuccess = () => seShowPaySuccess(false);
  const handleShowPaySuccess = () => {
    if (activeOrganizationId === "") {
      Alert.error(`<h4>Please select organization</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      const formData = {};
      formData.organizationId = activeOrganizationId;
      //formData.amount = amountTotal;
      formData.amount = 1;
      if (activeDonationType === "referal") {
        formData.referral_ids = checkedId;
      } else {
        formData.donation_ids = checkedId;
      }

      const token = props.auth.user.accessToken;
      props.donate_now_to_organization(token, formData, OnSuccessShowSUccess);
    }
  };

  const OnSuccessShowSUccess = () => {
    const token = props.auth.user.accessToken;
    setCheckedId([]);
    setAmountTotal(0);
    if (activeDonationType === "referal") {
      props.get_referal_donations(token, onSuccess);
    } else {
      props.get_all_donations(token, onSuccess);
    }
    seShowPaySuccess(true);
    seShowPay(false);
  };
  const [activeOrganizationId, setActiveOrganizationId] = useState("");

  const [activeDonationType, setActiveDonationType] = useState("order");

  useEffect(() => {
    const token = props.auth.user.accessToken;
    setCheckedId([]);
    setAmountTotal(0);
    if (activeDonationType === "referal") {
      props.get_referal_donations(token, onSuccess);
    } else {
      props.get_all_donations(token, onSuccess);
    }
  }, [activeDonationType]);

  const [search, setSearch] = useState("");

  const [checkedId, setCheckedId] = useState([]);
  const [amountTotal, setAmountTotal] = useState(0);
  const [organizationName, setOrganizationName] = useState([]);

  const checkUnCheckAll = (e) => {
    if (e.target.checked) {
      let result = filteredData.map((a) => a._id);
      let totalSum = 0;
      for (let i = 0; i < filteredData.length; i++) {
        if (activeDonationType === "referal") {
          totalSum +=
            filteredData[i] && parseInt(filteredData[i].amount_disbursement);
        } else {
          totalSum +=
            filteredData[i] &&
            filteredData[i].donation_amount &&
            filteredData[i].donation_amount.amount;
        }
      }

      setCheckedId(result);
      setAmountTotal(totalSum);
    } else {
      setCheckedId([]);
      setAmountTotal(0);
    }
  };

  const onChangeCheckUncheck = (id, amount) => {
    let existingData = [...checkedId];
    if (existingData.includes(id)) {
      existingData = existingData.filter((item) => item !== id);
      setAmountTotal(amountTotal - parseInt(amount));
    } else {
      existingData.push(id);
      setAmountTotal(amountTotal + parseInt(amount));
    }
    setCheckedId(existingData);
  };
  
  const onClickSearchButtonTop = () => {
    setDisplaySearch(!displaySearch);
  };

  var filteredData = [];

  if (activeDonationType === "referal") {
    filteredData =
      props &&
      props.all_donations &&
      props.all_donations.filter((item) => {
        return (
          item &&
          item.referee_id &&
          item.referee_id.first_name &&
          item.referee_id.first_name
            .toLowerCase()
            .includes(search.toLowerCase())
        );
      });
  } else {
    filteredData =
      props &&
      props.all_donations &&
      props.all_donations.sort(function (a, b) {
        let nameA = a && a.user_id && a.user_id.first_name.toUpperCase(); // ignore upper and lowercase
        let nameB = b && b.user_id && b.user_id.first_name.toUpperCase(); // ignore upper and lowercase
        if (sortBy === "a") {
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
        } else {
          if (nameB < nameA) {
            return -1;
          }
          if (nameB > nameA) {
            return 1;
          }
        }

        // names must be equal
        return 0;
      });
    filteredData = filteredData.filter((item) => {
      return (
        item &&
        item.user_id &&
        item.user_id.first_name &&
        item.user_id.first_name.toLowerCase().includes(search.toLowerCase())
      );
    });
    if (sortByDay !== 4) {
      filteredData = filteredData.filter((item) => {
        return (
          (startDay <= moment(item.createdAt).format("YYYY-MM-DD") ||
            startDay <= moment(item.updatedAt).format("YYYY-MM-DD")) &&
          (moment(item.createdAt).format("YYYY-MM-DD") <= endDay ||
            moment(item.updatedAt).format("YYYY-MM-DD") <= endDay)
        );
      });
    }
  }

  if (activeDonationType === "order") {
    filteredData = filteredData.filter((item) => {
      return item && item.is_event !== false;
    });
  } else if (activeDonationType === "events") {
    filteredData = filteredData.filter((item) => {
      return item && item.is_event === true;
    });
  } else if (activeDonationType === "scan") {
    filteredData = filteredData.filter((item) => {
      return (
        item &&
        item.transactional_id &&
        item.transactional_id.transaction_type === "SCAN_AND_PAY"
      );
    });
  } else if (activeDonationType === "referal") {
    if (state.restaurantReverse === "A-Z") {
      filteredData = filteredData.sort((a, b) => {
        if (
          a?.referee_id?.first_name + " " + a?.referee_id.last_name <
          b?.referee_id?.first_name + " " + b?.referee_id?.last_name
        )
          return -1;
        if (
          a?.referee_id?.first_name + " " + a?.referee_id.last_name >
          b?.referee_id?.first_name + " " + b?.referee_id?.last_name
        )
          return 1;
        return 0;
      });
    } else if (state.restaurantReverse === "Z-A") {
      filteredData = filteredData.sort((a, b) => {
        if (
          a?.referee_id?.first_name + " " + a?.referee_id.last_name <
          b?.referee_id?.first_name + " " + b?.referee_id?.last_name
        )
          return 1;
        if (
          a?.referee_id?.first_name + " " + a?.referee_id.last_name >
          b?.referee_id?.first_name + " " + b?.referee_id?.last_name
        )
          return -1;

        return 0;
      });
    }
    if (selectedReEfered !== "") {
      filteredData = filteredData.filter((donation) => {
        return donation && donation.referee_id_Role === selectedReEfered;
      });
    }
  }

  if (selectedOrder !== "")
    filteredData = filteredData.filter((donation) => {
      return (
        donation &&
        donation.order_id &&
        donation.order_id.order_type === selectedOrder
      );
    });

  if (selectedPayment !== "")
    filteredData = filteredData.filter((donation) => {
      return (
        donation &&
        donation.transactional_id &&
        donation.transactional_id.transaction_type === selectedPayment
      );
    });

  if (selectedPaymentRest !== "") {
    filteredData = filteredData.filter((donation) => {
      return (
        donation &&
        donation.restaurant_id &&
        donation.restaurant_id._id === selectedPaymentRest
      );
    });
  }
  const onSuccess = () => {};
  const onSuccessLoadOrganizations = (data) => {
    setOrganizationName(data);
  };
  useEffect(() => {
    const token = props.auth.user.accessToken;
    props.get_all_donations(token, onSuccess);
    props.get_all_organizations(token, onSuccessLoadOrganizations);
  }, []);
  const [restaurantData, setRestaurantData] = useState([]);
  useEffect(() => {
    if (activeDonationType !== "referal") {
      let restData = [];
      let restId = [];
      for (let i = 0; i < props?.all_donations.length; i++) {
        if (!restId.includes(props?.all_donations?.[i]?.restaurant_id?._id)) {
          restId.push(props?.all_donations?.[i]?.restaurant_id?._id);
          restData.push({
            id: props?.all_donations?.[i]?.restaurant_id?._id,
            title: props?.all_donations?.[i]?.restaurant_id?.restaurant_name,
          });
        }
      }
      setRestaurantData(restData);
    }
  }, [props?.all_donations]);

  const downloadData = {
    headers: [
      { label: "Referral ID", key: "id" },
      { label: "Referral Date", key: "date" },
      { label: "Referee Name", key: "name" },
      { label: "Referee Role", key: "Role" },
      { label: "Referred User ID", key: "userID" },
      { label: "Referred User Name", key: "userName" },
      { label: "Donation Amount", key: "Amount" },
    ],
    data: filteredData
      ? filteredData?.map((ele) => {
          return {
            id: ele?.referee_id?._id !== undefined ? ele?.referee_id._id : "-",
            date: moment(ele?.createdAt).format("hh:mm A"),
            name: `${
              ele?.referee_id?.first_name + " " + ele?.referee_id?.last_name
            }`,
            Role: ele?.referee_id_Role,
            userID: ele?.referred_id?._id,
            userName: `${
              ele?.referred_id?.first_name + " " + ele?.referred_id?.last_name
            }`,
            Amount: ele?.amount_disbursement,
          };
        })
      : [],
  };

  return (
    <React.Fragment>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="container-fluid">
            <div className="row">
              <div className="left-side-panel">
                <LeftSideNavigation displayLink={1} />
              </div>
              <div className="super-admin-right-side-panel">
                <HomeReusableTopBarNavigation />
                <div className="super-admin-inside-right-side-panel">
                  <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                    <div className="f24_700_HelveticaNeue">
                      Allocated Donations
                    </div>
                    <NavLink
                        to="/superadmindonationreport"
                        className="btn btn-outline-secondary btn-lg"
                        style={{borderRadius:"20px"}}
                      >
                        View Donation Report
                      </NavLink>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-4 pl-0">
                      <div className="d-flex align-items-center">
                        <Image
                          alt="Search"
                          title="Search"
                          width="80px"
                          src={require("../../../../assets/images/iconButton/newsearchicon.svg")}
                          onClick={() => onClickSearchButtonTop()}
                        />
                        <SortComponent
                          handleClick={handleClick}
                          anchorEl={state.anchorEl}
                          handleClose={handleClose}
                          selectClick={(data) => handleSelect(data)}
                        />
                        <Image
                          src={require("../../../../assets/images/iconButton/filterbtn.svg")}
                          width="80px"
                          alt="Filter"
                          title="Filter"
                          onClick={() => handleShowFilter()}
                        />
                        <div className="f10-400" align="center">
                          <CSVDownloader
                            filename={
                              "Notification -Template-Management-Reports"
                            }
                            headers={downloadData.headers}
                            data={downloadData.data}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-8 d-flex justify-content-end"> 
                     
                    </div>
                    <hr />
                    <div className="row align-items-center justify-content-end w-100 pl-4" >
                    <div className="col-3 pl-2">
                          <div className="mr-3 d-flex">
                            <SelectFilter
                              onDateChange={(data, type) =>
                                onDateChangeHandler(data, type)
                              }
                            />
                          </div>
                      </div>
                        <div className="col-5"> 
                        </div>
                        <div className="col-4 pr-0">
                        <div className="d-flex align-items-center justify-content-end">
                      <div
                        className="p-2 mr-3"
                        style={{ backgroundColor: "#e6e6ff", color: "#9900ff" ,minWidth: "150px",borderRadius:"10px" }}
                      >
                        <div className="f12-500" style={{ color: "#9900ff" }}>
                          Total No. of Requests
                        </div>
                        <div className="f18-700">{checkedId.length}</div>
                      </div>{" "}
                      <div
                        className="p-2"
                        style={{
                          backgroundColor: "#eafafa",
                          color: "#1d7c7c",
                          minWidth: "150px",
                          borderRadius:"10px"
                        }}
                      >
                        <div className="f12-500" style={{ color: "#1d7c7c" }}>
                          Total Amount
                        </div>
                        <div className="f18-700">₹ {amountTotal}</div>
                      </div>
                    
                        </div>
                    </div>
                    </div>
                
                  {/* <SuperAdminTopTextSearchIcon
                    showFilter={showFilter.showFilter}
                    handleShowFilter={handleShowFilter}
                    onChange={(e) => setSearch(e)}
                    search={search}
                    sortBy={sortBy}
                    changeSortBy={(e) => changeSortBy(e)}
                    sortByDay={sortByDay}
                    changeSortByDay={(e) => changeSortByDay(e)}
                    setSelectedOrderType={(e) => setSelectedOrderType(e)}
                    selectedOrderType={selectedOrderType}
                    onClickSearch={() => onClickSearch()}
                    onClickCancel={() => onClickCancel()}
                    selectedPaymentMethod={selectedPaymentMethod}
                    setSelectedPaymentMethod={(e) =>
                      setSelectedPaymentMethod(e)
                    }
                    restaurantData={restaurantData}
                    setSelectedPaymentTo={(e) => setSelectedPaymentTo(e)}
                    selectedPaymentTo={selectedPaymentTo}
                    activeDonationType={activeDonationType}
                    selectedReferedRole={selectedReferedRole}
                    setSelectedReferedRole={(e) => setSelectedReferedRole(e)}
                  /> */}
                  {displaySearch ? (
                    <React.Fragment>
                      <ZoomDiv>
                        <div className="mt-2">
                          <Paper component="form" className="enSearch2 d-flex">
                            <IconButton type="submit" aria-label="search">
                              <SearchIcon />
                            </IconButton>
                            <InputBase
                              placeholder="Search by name"
                              name="search"
                              inputProps={{
                                "aria-label": "Search by name",
                              }}
                              type="text"
                              onChange={(e) => setSearch(e.target.value)}
                              value={search}
                            />
                          </Paper>
                        </div>
                      </ZoomDiv>
                    </React.Fragment>
                  ) : null}
                  <div className="col-12 mt-3 d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                      <div
                        className={`mr-3 ${
                          activeDonationType === "order"
                            ? "selected-global-catalogue"
                            : ""
                        }`}
                        style={{ cursor: "pointer" }}
                        onClick={() => setActiveDonationType("order")}
                      >
                        Order
                      </div>
                      <div
                        className={`ml-4 mr-3 false ${
                          activeDonationType === "scan"
                            ? "selected-global-catalogue"
                            : ""
                        }`}
                        style={{ cursor: "pointer" }}
                        onClick={() => setActiveDonationType("scan")}
                      >
                        Scan & Pay
                      </div>
                      <div
                        className={`ml-4 mr-3 false ${
                          activeDonationType === "events"
                            ? "selected-global-catalogue"
                            : ""
                        }`}
                        style={{ cursor: "pointer" }}
                        onClick={() => setActiveDonationType("events")}
                      >
                        Events
                      </div>
                      <div
                        className={`ml-4 mr-3 false ${
                          activeDonationType === "referal"
                            ? "selected-global-catalogue"
                            : ""
                        }`}
                        style={{ cursor: "pointer" }}
                        onClick={() => setActiveDonationType("referal")}
                      >
                        Referal
                      </div>
                      <div
                        className=" ml-4 false"
                        style={{ cursor: "pointer" }}
                      >
                        Others
                      </div>
                    </div>
                    <div className="text-right">
                      <Button
                        variant="light"
                        // disabled
                        className={`btn-lg new-addcreate-button ${
                          checkedId.length === 0 ? "disabled" : ""
                        }`}
                        style={{color:'#EE3A23',fontSize:"18px",fontWeight:"500"}}
                        onClick={handleShowPay}
                      >
                        Donate Now
                      </Button>
                    </div>
                  </div>
                  <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                    <Table className="HideShowTable enMinWidth900">
                      {activeDonationType === "referal" ? (
                        <thead>
                          <tr className="super_admin_all_users_table_head">
                            <th style={{ width: 90 }} className="f12-700">
                              <Form.Check
                                label="1"
                                inline
                                className="enCheckBoxOnly"
                                onClick={(e) => checkUnCheckAll(e)}
                              />
                            </th>
                            <th style={{ width: "10%" }} className="f12-700">
                              Referral ID
                            </th>
                            <th style={{ width: "10%" }} className="f12-700">
                              Date
                            </th>

                            <th style={{ width: "15%" }} className="f12-700">
                              Referee Name
                            </th>
                            <th style={{ width: "10%" }} className="f12-700">
                              Referee Role
                            </th>
                            <th style={{ width: "15%" }} className="f12-700">
                              Referred User ID
                            </th>
                            <th style={{ width: "15%" }} className="f12-700">
                              Referred User Name
                            </th>
                            <th style={{ width: "15%" }} className="f12-700">
                              Donation Amount
                            </th>
                          </tr>
                        </thead>
                      ) : (
                        <thead>
                          <tr className="super_admin_all_users_table_head">
                            <th style={{ width: 90 }} className="f12-700">
                              <Form.Check
                                label="1"
                                inline
                                className="enCheckBoxOnly"
                                onClick={(e) => checkUnCheckAll(e)}
                              />
                            </th>
                            <th style={{ width: "10%" }} className="f12-700">
                              Transaction ID
                            </th>
                            <th style={{ width: "10%" }} className="f12-700">
                              Date
                            </th>
                            <th style={{ width: "10%" }} className="f12-700">
                              User ID
                            </th>
                            <th style={{ width: "15%" }} className="f12-700">
                              User
                            </th>
                            <th style={{ width: "10%" }} className="f12-700">
                              Request Type
                            </th>
                            <th style={{ width: "15%" }} className="f12-700">
                              Payment To
                            </th>
                            <th style={{ width: "15%" }} className="f12-700">
                              Payment Method
                            </th>
                            <th style={{ width: "15%" }} className="f12-700">
                              Donation Amount
                            </th>
                          </tr>
                        </thead>
                      )}

                      {activeDonationType === "referal" ? (
                        <tbody>
                          {filteredData &&
                            filteredData.map((donation, index) => (
                              <tr
                                className="super_admin_all_users_table_body"
                                key={index}
                              >
                                <td style={{ width: 90 }} className="f12-700">
                                  <Form.Check
                                    label="1"
                                    inline
                                    className="enCheckBoxOnly"
                                    checked={checkedId.includes(donation._id)}
                                    onClick={() =>
                                      onChangeCheckUncheck(
                                        donation._id,
                                        donation && donation.amount_disbursement
                                      )
                                    }
                                  />
                                </td>
                                <td style={{ width: "10%" }}>
                                  <div className="f12-400 text-break">
                                    {donation &&
                                      donation.referee_id &&
                                      donation.referee_id._id}
                                  </div>
                                </td>
                                <td style={{ width: "10%" }}>
                                  <div className="f12-400">
                                    {" "}
                                    {moment(donation.createdAt).format(
                                      "DD MMM, YYYY"
                                    )}
                                  </div>
                                </td>

                                <td style={{ width: "15%" }}>
                                  <div className="d-flex align-items-center">
                                    <div className="enIMG33 rounded-circle mr-3">
                                      <Image
                                        fluid
                                        src={require("../../../../assets/images/ActionImages/demoprofile.jpg")}
                                        alt="Icon"
                                      />
                                    </div>
                                    <div className="f12-400">
                                      {donation &&
                                        donation.referee_id &&
                                        donation.referee_id.first_name}{" "}
                                      {donation &&
                                        donation.referee_id &&
                                        donation.referee_id.last_name}
                                    </div>
                                  </div>
                                </td>
                                <td style={{ width: "10%" }}>
                                  <div className="f12-400">
                                    {donation && donation.referee_id_Role}
                                  </div>
                                </td>
                                <td style={{ width: "15%" }}>
                                  <div className="d-flex align-items-center">
                                    <div className="f12-400 text-break">
                                      {donation &&
                                        donation.referred_id &&
                                        donation.referred_id._id}
                                    </div>
                                  </div>
                                </td>
                                <td style={{ width: "15%" }}>
                                  <div className="f12-400">
                                    {donation &&
                                      donation.referred_id &&
                                      donation.referred_id.first_name}{" "}
                                    {donation &&
                                      donation.referred_id &&
                                      donation.referred_id.last_name}
                                  </div>
                                </td>
                                <td style={{ width: "15%" }}>
                                  <div className="f12-400">
                                    ₹ {donation && donation.amount_disbursement}
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      ) : (
                        <tbody>
                          {filteredData &&
                            filteredData.map((donation, index) => (
                              <tr
                                className="super_admin_all_users_table_body"
                                key={index}
                              >
                                <td style={{ width: 90 }} className="f12-700">
                                  <Form.Check
                                    label="1"
                                    inline
                                    className="enCheckBoxOnly"
                                    checked={checkedId.includes(donation._id)}
                                    onClick={() =>
                                      onChangeCheckUncheck(
                                        donation._id,
                                        donation &&
                                          donation.donation_amount &&
                                          donation.donation_amount.amount
                                      )
                                    }
                                  />
                                </td>
                                <td style={{ width: "10%" }}>
                                  <div className="f12-400 text-break">
                                    {donation &&
                                      donation.transactional_id &&
                                      donation.transactional_id._id}
                                  </div>
                                </td>
                                <td style={{ width: "10%" }}>
                                  <div className="f12-400">
                                    {" "}
                                    {moment(donation.createdAt).format(
                                      "DD MMM, YYYY"
                                    )}
                                  </div>
                                </td>
                                <td style={{ width: "10%" }}>
                                  <div className="f12-400 text-break">
                                    {donation &&
                                      donation.user_id &&
                                      donation.user_id._id}
                                  </div>
                                </td>
                                <td style={{ width: "15%" }}>
                                  <div className="d-flex align-items-center">
                                    <div className="enIMG33 rounded-circle mr-3">
                                      <Image
                                        fluid
                                        src={require("../../../../assets/images/ActionImages/demoprofile.jpg")}
                                        alt="Icon"
                                      />
                                    </div>
                                    <div className="f12-400">
                                      {donation &&
                                        donation.user_id &&
                                        donation.user_id.first_name}{" "}
                                      {donation &&
                                        donation.user_id &&
                                        donation.user_id.last_name}
                                    </div>
                                  </div>
                                </td>
                                <td style={{ width: "10%" }}>
                                  <div className="f12-400">
                                    {donation &&
                                    donation.order_id &&
                                    donation.order_id.order_type === 0
                                      ? "takeaway"
                                      : donation &&
                                        donation.order_id &&
                                        donation.order_id.order_type === 1
                                      ? "curb side"
                                      : props.orderDetails &&
                                        donation &&
                                        donation.order_id &&
                                        donation.order_id.order_type === 3
                                      ? "dine in"
                                      : ""}
                                  </div>
                                </td>
                                <td style={{ width: "15%" }}>
                                  <div className="d-flex align-items-center">
                                    <div className="enIMG33 rounded-circle mr-3">
                                      <Image
                                        fluid
                                        src={
                                          donation &&
                                          donation.restaurant_id &&
                                          donation.restaurant_id.logo_url
                                        }
                                        alt="restaurant icon "
                                      />
                                    </div>
                                    <div className="f12-400">
                                      {donation &&
                                        donation.restaurant_id &&
                                        donation.restaurant_id.restaurant_name}
                                    </div>
                                  </div>
                                </td>
                                <td style={{ width: "15%" }}>
                                  <div className="f12-400">
                                    {donation.transactional_id
                                      .transaction_type === "SCAN_AND_PAY"
                                      ? "Scan & Pay"
                                      : "Razor Pay"}
                                  </div>
                                </td>
                                <td style={{ width: "15%" }}>
                                  <div className="f12-400">
                                    ₹{" "}
                                    {donation &&
                                      donation.donation_amount &&
                                      donation.donation_amount.amount}
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      )}
                    </Table>
                  </div>
                  {filteredData?.length > 0 ? (
                    <BasicPagination
                      totalRecords={filteredData.length}
                      limit={10}
                      batch={page}
                      onBatchChange={(e) => handleBatchChange(e)}
                    />
                  ) : (
                    <> </>
                  )}
                  <Modal show={showPay} onHide={handleClosePay} centered>
                    <Modal.Header className="py-0 pt-2 border-0" closeButton>
                      <Modal.Title></Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="f16-500 p-0">
                      <div className="f16-500 px-4 pb-4">
                        Please select the organization to which you want to
                        donate the amount
                      </div>
                      <div className="bg-yellow-light px-4 py-2 d-flex align-items-center">
                        <div className="enIMG62 bg-white rounded-circle mr-3 d-flex align-items-center justify-content-center">
                          <Image
                            fluid
                            src={require("../../../../assets/images/UserManagement/donate.svg")}
                            alt="Icon"
                            className="w-50"
                          />
                        </div>
                        <div>
                          <div className="f20-700 pb-2">₹ {amountTotal}</div>
                          <div className="f11-400">Donation Amount</div>
                        </div>
                      </div>
                      <Form className="p-4">
                        <Form.Group>
                          <FormControl variant="outlined" className="w-100">
                            <InputLabel htmlFor="outlined-organization">
                              Select Organization
                            </InputLabel>
                            <Select
                              value={activeOrganizationId}
                              onChange={(e) =>
                                setActiveOrganizationId(e.target.value)
                              }
                              label="Select Organization"
                              inputProps={{
                                name: "organization",
                                id: "outlined-organization",
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              {/* <option value={"Organization"}>
                                Organization
                              </option> */}
                              {organizationName.map((name, index) => (
                                <option key={index} value={name._id}>
                                  {name.organization_name}
                                </option>
                              ))}
                            </Select>
                          </FormControl>
                        </Form.Group>
                        <div className="pt-4 d-flex align-items-center">
                          <Button
                            variant="outline-secondary"
                            className="btn-lg btn150px mr-4 px-5"
                            onClick={handleClosePay}
                          >
                            Cancel
                          </Button>
                          <Button
                            variant="danger"
                            className="btn-lg btn150px px-5"
                            onClick={handleShowPaySuccess}
                          >
                            Confirm
                          </Button>
                        </div>
                      </Form>
                    </Modal.Body>
                  </Modal>
                  <Modal
                    show={showPaySuccess}
                    onHide={handleClosePaySuccess}
                    centered
                  >
                    <Modal.Header className="py-0 pt-2 border-0" closeButton>
                      <Modal.Title className="f24_500_HelveticaNeue">
                        Success
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="f13-400 mb-4">
                        Your transaction request is successful. The money will
                        be reflected in account soon.
                      </div>
                      <Button
                        variant="danger"
                        className="btn-lg px-4"
                        onClick={handleClosePaySuccess}
                      >
                        Okay
                      </Button>
                    </Modal.Body>
                  </Modal>
                </div>
              </div>
            </div>
           </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

SuperAdminDonation.propTypes = {
  auth: PropTypes.object.isRequired,
  get_all_organizations: PropTypes.func.isRequired,
  get_all_donations: PropTypes.func.isRequired,
  donate_now_to_organization: PropTypes.func.isRequired,
  get_referal_donations: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  all_donations: state.superadminManageTransactions.all_donations,
});

export default connect(mapStateToProps, {
  get_all_donations,
  get_all_organizations,
  donate_now_to_organization,
  get_referal_donations,
})(SuperAdminDonation);
